import { z } from 'zod'

import { PlatformWidePermission } from '../auth-claims/permissions'
import { defineApi } from '../http'
import { NotificationChannel } from '../notification/channel'

export const notificationSettingsSchema = z.record(
  z.string(),
  z.object({
    enabledChannels: z.record(z.enum(NotificationChannel), z.boolean())
  })
)

export type NotificationSettings = z.infer<typeof notificationSettingsSchema>

export const notificationSettingsWithMetadataSchema = z.object({
  settings: notificationSettingsSchema,
  updatedAt: z.coerce.date()
})

export type NotificationSettingsWithMetadata = z.infer<
  typeof notificationSettingsWithMetadataSchema
>

export const getNotificationSettingsApi = defineApi({
  pathSchema: z.object({
    username: z.string()
  }),
  pathFor: (p) => `/notifications/settings/${p.username}`,
  gatewayPath: '/settings/:username' as const,
  name: 'GetNotificationSettings',
  description: 'Get notification preferences for a user across all notification types and channels',
  requiredPermissions: PlatformWidePermission.PerformBasicUserActions,
  responseSchema: notificationSettingsWithMetadataSchema
})

export const updateNotificationSettingsApi = defineApi({
  pathSchema: z.object({
    username: z.string()
  }),
  pathFor: (p) => `/notifications/settings/${p.username}`,
  gatewayPath: '/settings/:username' as const,
  name: 'UpdateNotificationSettings',
  description:
    'Update notification preferences for a user to enable/disable specific notification channels',
  requiredPermissions: PlatformWidePermission.PerformBasicUserActions,
  method: 'PUT',
  requestBodySchema: notificationSettingsSchema,
  responseSchema: z.void()
})
